import {compose as C, join, props } from 'ramda';
import { color, interpolateRgbBasis, range } from "d3";

export const hashCodeFromSeat = x => 
    x.split("-").map(x => String.fromCharCode(Number(x)+64+(Number(x) > 25 ? 7 : 0))).join("")

export const seatFromHashCode = x => 
    x.split("").map(x => x.charCodeAt(0)-64-(x.charCodeAt(0)>96 ? 7 : 0) ).join("-")

export const the_key = C(join("-"),props(["area", "row", "seat"]));

export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export const safeNumber = (v, fallback = 0) =>
  (typeof v === "number" && !isNaN(v) && isFinite(v)) ? v : fallback;

export const randomDelay = (min = 50, max = 200) => 
  Math.floor(Math.random() * (max - min + 1)) + min;

export const get_eventId = x => x.pathname.split("/")[2].split("-")[1]

export const createColors = (input_colors,n) => {
    const interpolator = interpolateRgbBasis(input_colors);
    return range(n).map(i => color(interpolator(i / (n - 1))).formatHex());
}